import React from "react";
import { useLocation } from "react-router-dom";
import "./AURVisualEnvironment.css";

const BRANDED_EXCEPTIONS = new Set([
  "/mirror-of-the-mind/book/product",
]);

const UNBRANDED_EXACT_ROUTES = new Set([
  "/mirror-of-the-mind",
  "/mirror-of-the-mind/about",
  "/mirror-of-the-mind/book",
]);

function shouldShowAurEnvironment(pathname) {
  if (UNBRANDED_EXACT_ROUTES.has(pathname)) return false;
  if (BRANDED_EXCEPTIONS.has(pathname)) return true;
  if (pathname.startsWith("/mirror-of-the-mind/book/")) return false;
  return true;
}

function AURVisualEnvironment({ children }) {
  const location = useLocation();
  const showAurEnvironment = shouldShowAurEnvironment(location.pathname);

  return (
    <>
      {showAurEnvironment && (
        <div
          className="aur-visual-environment"
          aria-hidden="true"
          data-testid="aur-visual-environment"
        >
          <picture className="aur-visual-environment__picture">
            <source
              media="(max-width: 768px)"
              srcSet="/aur-brand/aur-mirror-of-the-mind-vertical.png"
            />
            <img
              src="/aur-brand/aur-mirror-of-the-mind-horizontal.png"
              alt=""
              className="aur-visual-environment__image"
              draggable="false"
            />
          </picture>
        </div>
      )}

      {children}
    </>
  );
}

export default AURVisualEnvironment;
